import classNames from 'classnames';
import * as React from 'react';
import { Collapse } from 'react-collapse';

import { ValidationIssue, ValidationType } from './FormInterfaces';

interface FormInputValidationIssuesProps {
    validationIssue?: ValidationIssue[];
}

export const FormInputValidationIssues = (props: FormInputValidationIssuesProps) => {
    return (
        <Collapse isOpened>
            <div className="NewForm__ValidationWrapper">
                {props.validationIssue?.map((x) => (
                    <span key={x.message} className={classNames(x.type === ValidationType.Error ? 'NewForm__FieldError' : 'NewForm__FieldWarning')}>
                        {x.message}
                    </span>
                ))}
            </div>
        </Collapse>
    );
};
